import React from "react";
import ManagementToolbar from "../../../../../../components/reusable/management/ManagementToolbar";

const TeamToolbar = ({
    filters = { search: "", status: "" },
    filterOptions = {},
    teamCount = 0,
    onChange,
    onReset,
}) => {
    // const statuses = filterOptions.statuses || [];

    // STATUS OPTIONS
    const statusOptions = [
        { value: "active", label: "Active" },
        { value: "inactive", label: "Inactive" },
    ];

    // CHANGE HANDLER
    const handleChange = (nextFilters) => { onChange?.(nextFilters); };

    return (
        // <div
        //     style={{
        //         display: "flex",
        //         alignItems: "center",
        //         gap: "12px",
        //         flexWrap: "wrap",
        //         marginBottom: "20px",
        //         padding: "14px",
        //         background: "#ffffff",
        //         border: "1px solid #e2e8f0",
        //         borderRadius: "12px",
        //     }}
        // >
        //     {/* SEARCH */}
        //     <input
        //         type        = "text"
        //         value       = { filters.search || "" }
        //         onChange    = { (event) => onChange?.({ search: event.target.value }) }
        //         placeholder = "Search teams..."
        //         style       = {{
        //             flex: "1 1 260px",
        //             minWidth: "220px",
        //             padding: "10px 12px",
        //             border: "1px solid #cbd5e1",
        //             borderRadius: "8px",
        //             outline: "none",
        //             fontSize: "14px",
        //         }}
        //     />

        //     {/* STATUS */}
        //     <select
        //         value    = {  filters.status || "" }
        //         onChange = { (event) => onChange?.({ status: event.target.value }) }
        //         style    = { {
        //             minWidth: "150px",
        //             padding: "10px 12px",
        //             border: "1px solid #cbd5e1",
        //             borderRadius: "8px",
        //             background: "#ffffff",
        //             fontSize: "14px",
        //             cursor: "pointer",
        //         }}
        //     >
        //         {statuses.map(
        //             (status) => (
        //                 <option
        //                     key={ status.value }
        //                     value={ status.value }
        //                 >
        //                     { status.label }
        //                 </option>
        //             )
        //         )}
        //     </select>

        //     {/* COUNT */}
        //     <span
        //         style={{
        //             fontSize: "13px",
        //             color: "#64748b",
        //             whiteSpace: "nowrap",
        //         }}
        //     >
        //         {teamCount}{" "}
        //         {teamCount === 1 ? "team" : "teams"}
        //     </span>

        //     {/* RESET */}
        //     <button
        //         type="button"
        //         onClick={ onReset }
        //         style={{
        //             border: "1px solid #cbd5e1",
        //             background: "#ffffff",
        //             borderRadius: "8px",
        //             padding: "10px 14px",
        //             cursor: "pointer",
        //             color: "#334155",
        //             fontWeight: 600,
        //         }}
        //     >
        //         Reset
        //     </button>
        // </div>

        <ManagementToolbar
            values            = { filters }
            searchPlaceholder = "Search team members..."
            filters           = {[
                {
                    key:         "status",
                    label:       "Status",
                    placeholder: "All Statuses",
                    options:     statusOptions,
                },
            ]}

            onChange          = { handleChange }
            onReset           = { onReset }
            resultCount       = { teamCount }
            resultLabel       = "teams"
            showCount
        />
    );
};

export default TeamToolbar;
